import UserTraceService from '@/core/connector/userTrace.service';
import { isObject } from '@/core/helper/Helper';

export default class TracksServices {
  userTrace;

  tryCount;

  constructor() {
    this.tryCount = 0;
    this.userTrace = new UserTraceService();
  }

  parse(result) {
    Object.keys(result).forEach((key) => {
      if (isObject(result[key])) {
        Object.keys(result[key]).forEach((nestedKey) => {
          result[`${key}__${nestedKey}`] = result[key][nestedKey];
        });
        delete result[key];
      }
    });
  }

  mapFields(info) {
    const result = { ...info };

    const fields = [
      'ip',
      'continent_code',
      'continent_name',
      'country_code2',
      'country_code3',
      'country_name',
      'country_capital',
      'state_prov',
      'district',
      'city',
      'zipcode',
      'latitude',
      'longitude',
      'is_eu',
      'calling_code',
      'country_tld',
      'languages',
      'country_flag',
      'geoname_id',
      'isp',
      'connection_type',
      'organization',
      'asn',
      'userAgentString',
      'name',
      'type',
      'version',
      'versionMajor',
      'currency__code',
      'currency__name',
      'currency__symbol',
      'time_zone__name',
      'time_zone__offset',
      'time_zone__current_time',
      'time_zone__current_time_unix',
      'time_zone__is_dst',
      'time_zone__dst_savings',
      'device__name',
      'device__type',
      'device__brand',
      'device__CPU',
      'engine__name',
      'engine__type',
      'engine__version',
      'engine__versionMajor',
      'operatingSystem__name',
      'operatingSystem__type',
      'operatingSystem__version',
      'operatingSystem__versionMajor',
    ];
    Object.keys(result).forEach((infoKey) => {
      if (!fields.includes(infoKey)) {
        delete result[infoKey];
      }
    });

    return result;
  }

  // eslint-disable-next-line consistent-return
  async fetch() {
    this.tryCount += 1;

    const ipGeoPromise = this.userTrace.fetchIpGeo();
    const userAgentPromise = this.userTrace.fetchUserAgent();
    const [{ data: ipGeo }, { data: userAgent }] = await Promise.all([ipGeoPromise, userAgentPromise]);
    const result = { ...ipGeo, ...userAgent };

    this.parse(result);

    if (Object.keys(result).length > 10) {
      return this.mapFields(result);
    }

    if (this.tryCount < 5) {
      await this.fetch();
    } else {
      throw ['Invalid Request!'];
    }
  }
}
